import * as React from 'react'

import { cn } from '@/shared/ui/cn'

type EmptyStateSize = 'default' | 'compact'

type EmptyStateProps = {
  icon?: React.ComponentType<{ className?: string }>
  heading: string
  description?: string
  action?: React.ReactNode
  className?: string
  size?: EmptyStateSize
}

function EmptyState({
  icon: Icon,
  heading,
  description,
  action,
  className,
  size = 'default',
}: EmptyStateProps) {
  const isCompact = size === 'compact'
  return (
    <div
      data-slot="empty-state"
      className={cn(
        'flex flex-col items-center justify-center text-center',
        isCompact ? 'gap-1 py-4' : 'gap-2 py-10',
        className,
      )}
    >
      {Icon ? (
        <Icon
          className={cn(
            'text-muted-foreground',
            isCompact ? 'size-6' : 'size-10',
          )}
        />
      ) : null}
      <h2 className={cn('font-semibold', isCompact ? 'text-base' : 'text-lg')}>
        {heading}
      </h2>
      {description ? (
        <p className="text-sm text-muted-foreground">{description}</p>
      ) : null}
      {action ? <div data-slot="empty-state-action">{action}</div> : null}
    </div>
  )
}

export { EmptyState }
export type { EmptyStateProps }
